const { string, shape } = require('prop-types');

const Phone = shape({
  number: string.isRequired,
  extension: string,
});

module.exports = {
  drc: Phone,
  crc: Phone,
  claims: Phone,
  alternate: Phone,
  toll: Phone,
  cell: Phone,
  fax: Phone,
  bind: Phone,
  currentCustomerContact: Phone,
  crossSell: Phone,
  crossSellOptIn: Phone,
  crossSellPurchaseComplete: Phone,
  dvu: Phone,
  clsc: Phone,
};
